import {
  Alert,
  Button,
  Paragraph,
  SectionHeading,
} from '@quickmd-llc/design-system';

interface Props {
  handleClose: () => void;
  isOpen: boolean;
}

export default function ReservationUnavailableAlert({
  handleClose,
  isOpen,
}: Props): JSX.Element {
  return (
    <Alert open={isOpen} onClose={handleClose} size="sm">
      <SectionHeading className="mb-6">
        Please Select a Different Visit
      </SectionHeading>

      <Paragraph size="sm" className="mb-6 text-left">
        We can’t reserve your visit until after your account is created, and
        unfortunately the visit you selected has been booked. Please select
        another visit slot.
      </Paragraph>

      <div className="flex justify-end">
        <Button onClick={handleClose}>I understand</Button>
      </div>
    </Alert>
  );
}
